import { detectionsFr as libDetectionFr } from '@rfc/rfc-components-library/locales'
import { EDetectionActions } from '@rfc/rfc-components-library/store'

export const detectionsFr = {
    ...libDetectionFr,
    api: {
        error: {
            ...libDetectionFr.api.error,
            [EDetectionActions.EXPORT_DETECTIONS]: "Erreur pendant l'export des détections",
            [EDetectionActions.FETCH_DETECTIONS]: 'Erreur pendant la récupération des détections'
        },
        success: {
            ...libDetectionFr.api.success,
            [EDetectionActions.EXPORT_DETECTIONS]: 'Le fichier a bien été généré',
            [EDetectionActions.FETCH_DETECTIONS]: 'Détections correctement récupérées'
        }
    },
    actions: {
        resetFilters: {
            button: 'Réinitialiser les filtres',
            title: 'Réinitialiser les filtres courants',
            text: 'Souhaitez-vous vraiment réinitialiser les filtres courants ?'
        }
    },
    export: {
        allDetections: 'Toutes les détections',
        currentPage: 'Uniquement la page actuelle (Page {page})',
        device: 'Appareil'
    },
    filters: {
        ...libDetectionFr.filters,
        bib: 'Bib',
        checkpoint: 'Checkpoint',
        event: 'Évènement',
        eventId: 'Event ID',
        timerId: 'Timer ID'
    },
    model: {
        ...libDetectionFr.model,
        bib: 'Bib',
        eventName: "Nom de l'évènement",
        checkpointName: 'Nom du checkpoint',
        eventFilter: 'Event filter',
        timerFilter: 'Timer filter',
        withdrawal: 'Abandon'
    },
    table: {
        ...libDetectionFr.table,
        bib: 'Bib',
        checkpointName: 'Checkpoint',
        eventName: 'Évènement',
        eventFilter: "ID de l'évènement",
        timerFilter: 'ID du chronométreur'
    }
}
